import React from 'react';

import { SimpleDropdown } from '../../../../../../components/simple-dropdown';

import { PickSetting } from '../../../components/pick-setting/pick-setting';
import style from '../style.module.less';

/**
 * Universal dropdown setting component for pick list settings
 * @param {object} props
 * @param {string} props.value - The currently selected value
 * @param {(value: string) => void} props.onChange - Callback when selection changes
 * @param {Array<{key: string, name: string}>} props.items - Dropdown items
 * @param {object} props.titleMessage - React Intl message object for the title
 * @param {boolean} [props.disabled] - disable the dropdown
 * @param {object} [props.descriptionMessage] - Optional React Intl message object for the description
 * @returns {JSX.Element}
 */
export const PickListDropdownSetting = ({ value, onChange, items, titleMessage, descriptionMessage, disabled = false }) => {
  return (
    <PickSetting
      control={
        <div className={style['dropdown-option-wrapper']}>
          <SimpleDropdown
            disabled={disabled}
            dropdownMenuShouldHaveWidthOfButton
            items={items}
            onItemSelected={onChange}
            selectedItemKey={value}
          />
        </div>
      }
      descriptionMessage={descriptionMessage}
      titleMessage={titleMessage}
    />
  );
};
